module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"btn-upload-files":"Datei hochladen"},"fr":{"btn-upload-files":"Télécharger fichier"},"it":{"btn-upload-files":"Caricare file"}}')
  delete Component.options._Ctor
}
